// src/config/theme.ts
import { createTheme, MantineColorsTuple } from '@mantine/core';

const exportGreen: MantineColorsTuple = [
  '#f0f9f0',
  '#e0f0e0',
  '#c0e0c0',
  '#a0d0a0',
  '#80c080',
  '#60b060',
  '#40a040',
  '#208020',
  '#006600',
  '#004d00',
];

export const theme = createTheme({
  primaryColor: 'exportGreen',
  colors: {
    exportGreen,
  },
  fontFamily: 'Poppins, sans-serif',
  headings: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '600',
  },
  components: {
    Button: {
      defaultProps: {
        size: 'md',
        radius: 'md',
      },
      styles: {
        root: {
          transition: 'all 0.2s ease',
        },
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        withBorder: true,
      },
    },
    Container: {
      defaultProps: {
        size: 'xl',
      },
    },
  },
  // Mantine v7 no longer supports globalStyles in createTheme.
  // Instead, add global styles via CSS or MantineProvider's globalStyles prop.
  // For simplicity, we'll remove it here; you can add CSS in index.css.
});